import { render, staticRenderFns } from "./LogsDetail.vue?vue&type=template&id=746758a9"
import script from "./LogsDetail.vue?vue&type=script&lang=js"
export * from "./LogsDetail.vue?vue&type=script&lang=js"
import style0 from "./LogsDetail.vue?vue&type=style&index=0&id=746758a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports